import { Dispatch } from 'redux';
import { UseFormReturn } from 'react-hook-form';
import { deskingActions } from '../model';
import { FinanceProgramFormValues } from '../types';
import { convertProgramConfigToFormValues } from './convertProgramConfigToFormValues';

interface Options {
  programConfig: any;
  dispatch: Dispatch<any>;
  setValue: UseFormReturn<FinanceProgramFormValues>['setValue'];
}

export function setProgramDeps({ programConfig, setValue, dispatch }: Options) {
  if (!programConfig) return;

  const values = convertProgramConfigToFormValues(programConfig);

  if (values.terms?.length) {
    dispatch(deskingActions.setMenuTerm({ index: values.terms.length - 1, term: values.terms.at(-1) }));
  }

  Object.entries(values).forEach(([key, value]) => setValue(`financeQuote.${key}` as any, value));
}
